import { render, staticRenderFns } from "./PAMM.vue?vue&type=template&id=b20ffcf4&scoped=true&"
import script from "./PAMM.vue?vue&type=script&lang=js&"
export * from "./PAMM.vue?vue&type=script&lang=js&"
import style0 from "./PAMM.vue?vue&type=style&index=0&id=b20ffcf4&scoped=true&lang=scss&"
import style1 from "./PAMM.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20ffcf4",
  null
  
)

export default component.exports